const ChargeStatus = Object.freeze({
  PENDING: 'Pending',
  PAID: 'Paid',
  OVERDUE: 'Overdue',
  REFUNDED: 'Refunded',
})

export default ChargeStatus